import { render, staticRenderFns } from "./ActionCompo.vue?vue&type=template&id=e1f6a946&scoped=true&"
import script from "./ActionCompo.vue?vue&type=script&lang=js&"
export * from "./ActionCompo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f6a946",
  null
  
)

export default component.exports